// extracted by mini-css-extract-plugin
export default {"item":"GalleryCard_item__lbDRM","item__cover":"GalleryCard_item__cover__XJdoY","item__cover--img":"GalleryCard_item__cover--img__VXZoI","item__text":"GalleryCard_item__text__60irZ"};